import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';

const AutoSaveIndicator = ({ isSaving = false, lastSaved = null, error = null }) => {
  const [showSaved, setShowSaved] = useState(false);

  useEffect(() => {
    if (lastSaved && !isSaving) {
      setShowSaved(true);
      const timer = setTimeout(() => {
        setShowSaved(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [lastSaved, isSaving]);

  const formatLastSaved = (date) => {
    if (!date) return '';
    const now = new Date();
    const diff = Math.floor((now - date) / 1000);

    if (diff < 60) return 'just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return date?.toLocaleDateString();
  };

  if (error) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-destructive/10 rounded-lg">
        <Icon name="AlertCircle" size={16} className="text-destructive" />
        <span className="text-sm text-destructive">Save failed</span>
      </div>
    );
  }

  if (isSaving) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-muted rounded-lg">
        <div className="animate-spin">
          <Icon name="Loader2" size={16} className="text-muted-foreground" />
        </div>
        <span className="text-sm text-muted-foreground">Saving...</span>
      </div>
    );
  }

  if (showSaved && lastSaved) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-success/10 rounded-lg">
        <Icon name="Check" size={16} className="text-success" />
        <span className="text-sm text-success">Saved {formatLastSaved(lastSaved)}</span>
      </div>
    );
  }

  if (lastSaved) {
    return (
      <div className="flex items-center gap-2 px-3 py-2">
        <Icon name="Clock" size={16} className="text-muted-foreground" />
        <span className="text-sm text-muted-foreground">Last saved {formatLastSaved(lastSaved)}</span>
      </div>
    );
  }

  return null;
};

export default AutoSaveIndicator;